/**
 * This file consist of all the API url that has been used in NGI APIS.
 */

import { AUTH_OBJECT_KEY_NAME } from "Common/constants/commonConstants.js";

/**
 *
 * @type {Number}
 * constants for interval used for making api calls in NGI
 */
const NGI_APIS_INTERVAL = Number.parseInt(process.env.NGI_APIS_INTERVAL, 10) || 60000;
const NGI_APIS_INTERVAL_30_SECS = Number.parseInt(process.env.NGI_APIS_INTERVAL_30_SECS, 10) || 30000;
const FILE_DOWNLOAD_BASE_URL = "/filedownload/instrument/";
/**
 *  component Urls
 */
function getBasicDeviceSearchUrl(...params) {
  var [instanceId] = params;

  return {
    url: process.env.APP_SERVICE + "/deviceManagement/devices/" + instanceId,

    repeat: true,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: instanceId }
  };
}

function getPrimaryInstanceIdUrl(instanceId) {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/devices/" + instanceId + "/primaryInstanceId",
    repeat: true,
    interval: NGI_APIS_INTERVAL_30_SECS,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: instanceId }
  }
}

function getDeviceHeartBeatUrl(instanceId) {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/devices/" + instanceId + "/heartBeat",
    repeat: true,
    interval: NGI_APIS_INTERVAL_30_SECS,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: instanceId }
  }
}
function getDeviceDemographicsUrl(...params) {
  var [instanceId] = params;
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/devices/" + instanceId + "/demographics",
    repeat: true,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: instanceId }
  }
}

function getFileUploadDefPathsUrl(...params) {
  var [modelName, deviceId] = params;
  return {
    url: process.env.FILE_UPLOAD_URL + "/fileupload/defaultpath/" + modelName+"/"+deviceId,
    repeat: true,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  }
}

function getFileUploadDirListUrl(...params) {
  let [deviceId] = params;
  return {
    url: process.env.FILE_UPLOAD_URL + "/fileupload/listfiles",
    repeat: true,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  }
}

function getFilesUrl(...params) {
  let [deviceId, pageNum, pageSize, modelName] = params;
  if (!pageNum) {
    return {
      url: process.env.FILE_UPLOAD_URL + "/fileupload/files/" + modelName + "/" + deviceId,
      repeat: false,
      interval: NGI_APIS_INTERVAL,
      inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
    }
  } else {
    return {
      url: process.env.FILE_UPLOAD_URL + "/fileupload/files/" + modelName + "/" + deviceId + "?pageNum=" + pageNum + "&pageSize=" + pageSize,
      repeat: false,
      interval: NGI_APIS_INTERVAL,
      inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
    }
  }
}

function retrieveFilesUrl(deviceId) {
    return {
      url: process.env.FILE_UPLOAD_URL + "/fileupload/files/" + deviceId,
      repeat: false,
      interval: NGI_APIS_INTERVAL,
      inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
    }
  
}

function getFileDownloadUrl(...params) {
  let [deviceId, filePath, modelName] = params;
  return {
    url: process.env.FILE_UPLOAD_URL + "/fileupload/download/"+modelName+"/"+ deviceId + "?filePath=" + encodeURIComponent(filePath),
    repeat: false,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  }
}

function getRAPBoxSearchUrl() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/rapbox/search"
  };
}

function getRAPBoxUploadFileUrl() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/rapbox/uploadFile"
  };
}

function getRAPBoxTransferredFilesUrl() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/rapbox/transferredFiles"
  };
}

function getRAPBoxFileDownloadUrl(raId, cloudFilePath) {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/rapbox/" + encodeURIComponent(raId) + "/downloadFile?filePath=" + encodeURIComponent(cloudFilePath),
    inputHeader: {}
  };
}

function getLaunchRAPBoxRDSUrl(raId) {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/rapbox/" + encodeURIComponent(raId) + "/rdsProxyUrl",
    inputHeader: {}
  };
}

function getLaunchRAPBoxRDSSessionUrl(proxyURL) {
  return {
    url: proxyURL + "/launchRAPBoxRDS"
  };
}


function getFileUploadUrl(...params) {
  let [deviceId] = params;
  return {
    url: process.env.FILE_DOWNLOAD_URL + FILE_DOWNLOAD_BASE_URL + deviceId,
    repeat: false,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  }
}

function getFileDownloadHistoryUrl(...params) {
  let [deviceId] = params;
  return {
    url: process.env.FILE_DOWNLOAD_URL + FILE_DOWNLOAD_BASE_URL + deviceId + "/history",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  }
}

function getAllFilesHistoryUrl(...params) {
  let [deviceId] = params;
  return {
    url: process.env.FILE_DOWNLOAD_URL + FILE_DOWNLOAD_BASE_URL + deviceId + "/filesHistory",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  }
}

function getDeleteFilesUrl(...params) {
  let [deviceId] = params;
  return {
    url: process.env.FILE_DOWNLOAD_URL + FILE_DOWNLOAD_BASE_URL + deviceId + "/deleteFile",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  }
}
function getResendFilesUrl(...params) {
  let [deviceId] = params;
  return {
    url: process.env.FILE_DOWNLOAD_URL + FILE_DOWNLOAD_BASE_URL + deviceId + "/resendFile",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  }
}

function getDatalakeDetailsUrl(...params) {
  let [deviceId] = params;
  return {
    url: `${process.env.FILE_DOWNLOAD_URL}${FILE_DOWNLOAD_BASE_URL}${deviceId}/dataLakeDetails`,
    repeat: false,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  }
}
function getDeleteAllFilesUrl(...params) {
  let [deviceId] = params;
  return {
    url: process.env.FILE_DOWNLOAD_URL + FILE_DOWNLOAD_BASE_URL + deviceId + "/deleteAll",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  }
}

function getAllDevicesForUserUrl(...params) {
  let [getAllowedDevices] = params;
  return {
    url: process.env.USER_MANAGEMENT_URL + "/userManagement/preferredDevices" + "?getAllowedDevices=" + getAllowedDevices,
    repeat: false,
    interval: NGI_APIS_INTERVAL
  }
}

function getUserSettingPreferencesUrl() {
  return {
    url: process.env.USER_MANAGEMENT_URL + "/userManagement/UserSettingPreferences",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
  }
}


function getAllowedDeviceFeaturesUrl(instanceId) {
  return {
    url: process.env.APP_SERVICE + "/authorization/allowedFeatures/" + instanceId,
    repeat: false,
    interval: NGI_APIS_INTERVAL
  }
}

function getInstConnStatusInfoUrl(...params) {
  let [deviceId] = params;
  return {
    url : process.env.APP_SERVICE + "/deviceManagement/devices/" + deviceId + "/instConnStatus"
  }
}

function getTestsKpiInfoUrl(...params) {
  let [deviceId] = params;
  return {
    url : process.env.APP_SERVICE + "/deviceManagement/devices/" + deviceId + "/kpi"
  }
}

function getMetricsListViewDataUrl() {
  return {
    url: process.env.METRICS_URL + "/metrics/listview",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
  }
}

function getCriticalWarningUrl() {
  return {
    url: process.env.METRICS_URL + "/metrics/statsCardsCriticalWarning",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
  }
}

function getPatientTotalTestUrl() {
  return {
    url: process.env.METRICS_URL + "/metrics/statsCardsPatientTotalTest",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
  }
}

function getConnectivityUrl() {
  return {
    url: process.env.METRICS_URL + "/metrics/statsCards",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
  }
}

function getMetricFilterUrl() {
  return {
    url: process.env.METRICS_URL + "/metrics/filters",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
  }
}

function getBannerMessageUrl() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/bannerMessage",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
  }
}

function saveBannerMessageUrl() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/saveBannerMessage",
    repeat: false,
    interval: NGI_APIS_INTERVAL,
  }
}

function getRSUModUrl(...params) {
  let [dateTimeOrderDesc] = params;
  return {
    url: process.env.RSU_URL + "/rsu/modDetails" + "?dateTimeOrderDesc=" + dateTimeOrderDesc
  }
}

function getAllowedFeaturesUrl() {
  return {
    url: process.env.USER_MANAGEMENT_URL + "/userManagement/allowedFeaturesForUser",
  }
}

function getRolesForUserUrl() {
  return {
    url: process.env.USER_MANAGEMENT_URL + "/userManagement/getRolesForUser",
  }
}

function getRecentCalibandQCAssayNameApiURL(instanceId){
 return process.env.APP_SERVICE +"/deviceManagement/qastatus/recentRunAssay/" +instanceId;
  
}

function getRecentCalibandQCAssayLotNumberApiURL(instanceId){
 return  process.env.APP_SERVICE +"/deviceManagement/qastatus/recentLotNumbers/" +instanceId;
}

function getCalHistoryURL(instanceId){
  return  process.env.APP_SERVICE + "/deviceManagement/" + instanceId + "/calibrationhistory";
}

function getRBHistoryURL(instanceId){
  return  process.env.APP_SERVICE + "/deviceManagement/" + instanceId + "/rbhistory";
}

function getRecentMetricDataApiURL(instanceId){
 return   process.env.APP_SERVICE +"/deviceManagement/devices/" +instanceId +"/deviceComponents/recentMetricsInfo";
  }

function getWorkOrderStatusURL(workOrderId) {
  return {
    url:  process.env.RSU_URL+"/rsu/workorder/" + workOrderId + "/status"
  }
}

function getHomePageListViewURL() {
  return {
    url:  process.env.APP_SERVICE + "/deviceManagement/homePageListView"
  }
}

function getHomePageDropdownListURL() {
  return {
    url:  process.env.APP_SERVICE + "/deviceManagement/homepageFilterList"
  }
}
function getModActionURL() {
  return {
    url:  process.env.RSU_URL+"/rsu/modAction"
  }
}
/**
 * method which return an object having http request configuration for digicert fetch and create api
 * @returns {Object}
 */
function getCaCertURL() {
  return {
    url: process.env.CERTGEN_URL+"/certManagement/caCert"
  };
}
/**
 * method which return an object having http request configuration for digicert downnload api
 * @returns {Object}
 */
function getDownloadCaCertURL() {
  return {
    url: process.env.CERTGEN_URL+"/certManagement/caCert/downloadCert"
  }
}

function getFailedCalibIncidentURL(deviceId) {
  return {
    url:  process.env.APP_SERVICE + "/deviceManagement/devices/"+deviceId+"/incidents/Category/Calibration"
  }
}

function getFailedQCIncidentURL() {
  return {
    url:  process.env.APP_SERVICE + "/deviceManagement/qcLevel/"
  }
}

function getDeviceComponentListURL(region, model, deviceId) {
  return {
    url: `${process.env.APP_SERVICE}/deviceManagement/devices/${deviceId}/sysCompStatus?region=${region}&model=${model}`
  };
}

function getDeviceComponentMetricsURL(region, model, deviceId, deviceComponentName) {
  return {
    url: `${process.env.APP_SERVICE}/deviceManagement/devices/${deviceId}/sysCompMetrics?region=${region}&model=${model}&deviceComponentName=${deviceComponentName}`
  };
}

function getDeviceComponentMeasurementValsURL(region, model, deviceId, metricName, fromDate, toDate) {
  return {
    url: `${process.env.APP_SERVICE}/deviceManagement/devices/${deviceId}/measurements?region=${region}&model=${model}&metricName=${metricName}&fromDate=${fromDate}&toDate=${toDate}`
  };
}

function getIncidentDataURL(deviceID) {
  return {
    url:  process.env.APP_SERVICE + '/deviceManagement/devices/'+deviceID+'/incidents'
  }
}

function getCalAssaySummApiURL(){
  return  {
    url: process.env.APP_SERVICE +"/deviceManagement/calassay-summary"
  }
}

function getQCAssaySummApiURL(){
  return  {
    url: process.env.APP_SERVICE +"/deviceManagement/qcassay-summary"
  }
}
			   
function getEventDetailsURL(deviceId) {
  return {
    url:  process.env.APP_SERVICE + "/deviceManagement/devices/"+deviceId+"/events"
  }
}

function getUnenrollInstrumentURL() {
  
  return {
    url:  process.env.APP_SERVICE + "/deviceManagement/unenrollInstrument"

  }
}

function getEnrollmentStateURL(instanceId) {
  console.log("Instance Enrollment id is ",instanceId);

  return {
    url:  process.env.APP_SERVICE + "/deviceManagement/getEnrollmentState/"+instanceId

  }
}

function getHomePageStatCardsURL() {
  return {
    url:  process.env.APP_SERVICE + "/deviceManagement/homePageStatCards"
  }
}

function getInstrumentStatCardsURL(deviceID) {
  return {
    url:  process.env.APP_SERVICE + '/deviceManagement/devices/'+deviceID+'/instrumentPageStatCards'
  }
}

function getUserMangementURL() {
  return {
    url:  process.env.USER_MANAGEMENT_URL + '/userManagement/user/userDetails'
  }
}

function getUserMangementGroupDetailsURL(groupName) {
  return {
    url:  process.env.USER_MANAGEMENT_URL + '/userManagement/user/'+groupName+'/groupDetails'
  }
}


function getAddUserURL() {
  return {
    url:  process.env.APP_SERVICE + '/admin/authorization/addUsersToRole'
  }
}

function getReomveUserURL() {
  return {
    url:  process.env.APP_SERVICE + '/admin/authorization/removeUsersFromRole'
  }
}

function getUserAssignedGroupURL(userId) {
  return {
    url:  process.env.USER_MANAGEMENT_URL + '/userManagement/user/'+userId+'/userAssignedGroups'
  }
}

function getUnassignedDevicesURL() {
  return {
    url: `${process.env.APP_SERVICE}/deviceManagement/groupManagement/unassignedDevices`
  };
}

function getSearchDevicesURL(instanceSearchText) {
  return {
    url: `${process.env.APP_SERVICE}/deviceManagement/groupManagement/devicesByInstanceId?instanceSearchText=${instanceSearchText}`
  };
}

function getInstGroupDevicesURL(instrumentGroup) {
  return {
    url: `${process.env.APP_SERVICE}/deviceManagement/groupManagement/devicesByGroup?instrumentGroup=${instrumentGroup}`
  };
}

function getDeviceGroupsURL(instanceId) {
  return {
    url: `${process.env.APP_SERVICE}/admin/authorization/getDeviceGroups?instanceId=${instanceId}`
  };
}

function getAddOrRemoveDevicesToInstGroupURL() {
  return {
    url: `${process.env.APP_SERVICE}/admin/authorization/addOrRemoveDevicesToGroup`
  };
}

function getInstGroupsForMappingURL() {
  return {
    url: `${process.env.APP_SERVICE}/admin/authorization/getInstGroupsForMapping`
  };
}

function getfetchUserDetailsURL() {
  return {
    url:  process.env.USER_MANAGEMENT_URL + '/userManagement/ADUsers'
  };
}

function addUsertoISURL() {
  return {
    url:  process.env.USER_MANAGEMENT_URL + '/userManagement/ISUser'
  };
}

function getUserGroupsForMappingURL() {
  return {
    url: `${process.env.APP_SERVICE}/admin/authorization/getUserGroupsForMapping`
  };
}

function getAllowedModelsForMeteringURL() {
  return {
    url: `${process.env.APP_SERVICE}/deviceManagement/devices/meterData/models`
  };
}

function getMeterUploadHistoryFiltersURL(){
  return {
    url: `${process.env.APP_SERVICE}/deviceManagement/metering/uploads/uploadHistoryFilters`
  }
}

function getUpdateDeviceMeteringStatusURL(instanceId) {
  return {
    url: `${process.env.APP_SERVICE}/deviceManagement/devices/${instanceId}/meterData`
  };
};

function getMaxUnrollmentInstrumentCountURL(instanceId) {
  return {
    url: process.env.APP_SERVICE + '/deviceManagement/maxInsrumentUnenrollmentCount'
  };
};

function getMessageFreqModeURL(deviceId) {
  return {
    url: `${process.env.APP_SERVICE}/deviceManagement/devices/${deviceId}/messageFrequencyMode`
  };
};

function deleteUsertoISURL() {
  return {
    url:  process.env.USER_MANAGEMENT_URL + '/userManagement/ISUser'
  };
}

function getAdminAssignGroupURL(){
  return {
    url:  process.env.USER_MANAGEMENT_URL + '/userManagement/user/adminAssignedGroups'
  };
}

function getModelListURL() {
  return {
    url:  process.env.APP_SERVICE + '/deviceManagement/InstrumentModels'
  };
}

function fetchOnboardInstrumentModelURL(ModelName) {
  return {
    url:  process.env.APP_SERVICE + `/deviceManagement/${ModelName}/InstrumentModelData`
  };
}
function getMeteringDataFilterURL(){
  return {
    url:  process.env.APP_SERVICE + '/deviceManagement/metering/filters'
  };
}

function getMeteringDataURL(){
  return {
    url:  process.env.APP_SERVICE + '/deviceManagement/metering/meteringDataCountDetails'
  };
}

function getMeterZipUploadHistoryListURL(offset) {
  return {
    url: process.env.APP_SERVICE + `/deviceManagement/loadMeterZipUploadHistoryList/${offset}`,
    repeat: false,
    interval: NGI_APIS_INTERVAL,
  }
}
function getConfigForInstrumentModel() {
  return {
    url:  process.env.APP_SERVICE + '/deviceManagement/InstrumentModelConfig'
  };
}

function getSampleStatsDataURL(deviceId){
  return {
    url:  process.env.APP_SERVICE + "/deviceManagement/devices/"+deviceId+"/sampleStats"
  };
}

function uploadMeterZipURL(deviceID) {
  return {
    url:  process.env.APP_SERVICE + `/deviceManagement/devices/${deviceID}/meterZip`
  };
}

function getWatchlistURL() {
  return {
    url:  process.env.APP_SERVICE + `/deviceManagement/watchlist`
  };
}

function addOrRemoveFromWatchlistURL(instanceId) {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/watchlist/" + instanceId,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: instanceId }
  };
}

function getUserSearchHistoryURL() {
  return {
    url:  process.env.APP_SERVICE + `/deviceManagement/userSearchHistory`
  };
}

function getUserManualURL() {
  return {
    url: process.env.APP_SERVICE + `/deviceManagement/manual/`
  };
}

function getSiteViewFiltersURL() {
  return {
    url: process.env.APP_SERVICE + `/deviceManagement/siteViewFilters`
  };
}

function getCustomerSitesURL() {
  return {
    url: process.env.APP_SERVICE + `/deviceManagement/customerSites`
  };
}

function getSiteInstrumentsDataURL() {
  return {
    url: process.env.APP_SERVICE + `/deviceManagement/siteInstrumentsData`
  };
}
function getDiagnosticsTypeURL() {
  return {
    url: process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/diagnostictypes`
  };
}

function getDiagnosticsSupportURL(model) {
  return {
    url: process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/${model}/diagnosticSupportDetails`
  };
}

function getDiagDateURL(diagtype) {
  return {
    url: process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/${diagtype}/dateList`
  };
}

function getDiagDataURL(diagtype) {
  return {
    url: process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/${diagtype}/diagnosticData`
  };
}
function getAnalyzerUnitURL() {
  return {
    url: process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/analyzerUnits`
  };
}

function getPipettorMatchURL(pageSize = null, cursorTimestamp = null) {
  let baseUrl = process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/pipettorMatch/summary`;
  
  const params = new URLSearchParams();
  
  // Always include pageSize if provided
  if (pageSize) {
    params.append('pageSize', pageSize.toString());
  }
  
  // Include cursorTimestamp if provided (for pagination)
  if (cursorTimestamp) {
    params.append('cursorTimestamp', cursorTimestamp);
  }
  
  // Append query parameters if any exist
  if (params.toString()) {
    baseUrl += `?${params.toString()}`;
  }
  
  return {
    url: baseUrl
  };
}

function getPipettorMatchReportURL() {
  return {
    url: process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/pipettorMatch/report`
  };
}

function getCarryOverReportURL() {
  return {
    url: process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/carryover/report`
  };
}

function getCarryoverSummaryURL(pageSize = null, cursor = null) {
  let baseUrl = process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/carryover/summary`;
  
  const params = new URLSearchParams();
  
  // Always include pageSize if provided
  if (pageSize) {
    params.append('pageSize', pageSize.toString());
  }
  
  // Include cursor if provided (for pagination)
  if (cursor) {
    params.append('cursor', cursor);
  }
  
  // Append query parameters if any exist
  if (params.toString()) {
    baseUrl += `?${params.toString()}`;
  }
  
  return {
    url: baseUrl
  };
}

function getLowVolumeURL(pageSize = null, cursorTimestamp = null) {
  let baseUrl = process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/lowVolume/summary`;
  
  const params = new URLSearchParams();
  
  // Always include pageSize if provided
  if (pageSize) {
    params.append('pageSize', pageSize.toString());
  }
  
  // Include cursorTimestamp if provided (for pagination)
  if (cursorTimestamp) {
    params.append('cursorTimestamp', cursorTimestamp);
  }
  
  // Append query parameters if any exist
  if (params.toString()) {
    baseUrl += `?${params.toString()}`;
  }
  
  return {
    url: baseUrl
  };
}

function getLowVolumeReportURL() {
  return {
    url: process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/lowVolume/report`
  };
}

function getSystemCheckURL(pageSize = null, cursorTimestamp = null) {
  let baseUrl = process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/systemCheck/summary`;
  
  const params = new URLSearchParams();
  
  // Always include pageSize if provided
  if (pageSize) {
    params.append('pageSize', pageSize.toString());
  }
  
  // Include cursorTimestamp if provided (for pagination)
  if (cursorTimestamp) {
    params.append('cursorTimestamp', cursorTimestamp);
  }
  
  // Append query parameters if any exist
  if (params.toString()) {
    baseUrl += `?${params.toString()}`;
  }
  
  return {
    url: baseUrl
  };
}

function getSystemCheckReportURL() {
  return {
    url: process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/systemCheck/report`
  };
}

function getfetchDropdownOptionURL() {
  return {
    url: process.env.TRIGGERS_URL + `/triggers/filterOptions`
  };
}

function getfetchInstrumentsURL() {
  return {
    url: process.env.TRIGGERS_URL + `/triggers/instruments`
  };
}

function getfetchUserGroupDropdownOptionURL() {
  return {
    url: process.env.TRIGGERS_URL + `/triggers/userGroups`
  };
}

function getfetchUsersURL() {
  return {
    url: process.env.TRIGGERS_URL + `/triggers/users`
  };
}

function getfetchRulesURL(modelName) {
  return {
    url: process.env.TRIGGERS_URL + "/triggers/rules/"+modelName
  };
}

function getfetchCreateTriggerURL(){
  return {
    url: process.env.TRIGGERS_URL + "/triggers/createTrigger"
  };
}

function getfetchTriggerActivityURL(instanceId){
  return {
    url: process.env.TRIGGERS_URL + "/triggers/hasTriggerActivity/"+instanceId
  };
}

function getfetchTriggerAuditCountURL(instanceId){
  return {
    url: process.env.TRIGGERS_URL + "/triggers/triggerAuditCount/"+instanceId
  };
}

function getRuleSearchDataURL(instanceId){
  return {
    url: process.env.TRIGGERS_URL + "/triggers/ruleSearchData"
  };
}

function setTriggerStatusURL(){
  return {
    url: process.env.TRIGGERS_URL + "/triggers/triggerStatus"
  };
}

function getOfflineTriggerConfigURL(){
  return {
    url: process.env.TRIGGERS_URL + "/triggers/offlineTriggerConfig"
  };
}

function getRuleViewDataURL(){
  return {
    url: process.env.TRIGGERS_URL + "/triggers/ruleViewData"
  };
}

function getEditTriggerInfoURL(triggerId){
  return {
    url: process.env.TRIGGERS_URL + "/triggers/"+triggerId
  };
}

function deleteTriggerURL(){
  return {
    url: process.env.TRIGGERS_URL + "/triggers/deleteTriggers"
  };
}

function exportCSVPhotocalMonitorURL() {
  return {
    url: process.env.CLINICAL_DIAGNOSTIC_URL + `/clinicaldiagnostic/exportCSVPhotocalMonitor`
  };
}

function getMaintenanceDomainsUrl() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/maintenanceDomains"
  };
}

function getMaintenanceDataUrl() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/maintenanceData"
  };
}

function getMaintenanceDetailsUrl() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/maintenanceDetails"
  };
}

function getSupportedFeaturesForModelUrl(modelName) {
  return {
    url: process.env.APP_SERVICE + `/deviceManagement/${modelName}/supportedFeatures`
  }
}


function getRBreagentAndLotNumberUrl(deviceId) {
  return {
    url : process.env.APP_SERVICE + `/deviceManagement/${deviceId}/rbReagentDetails`
  }
}

function getRBReportUrl(deviceId) {
  return {
    url : process.env.APP_SERVICE + `/deviceManagement/${deviceId}/rbReport`
  }
}

function getRBDataUrl(deviceId) {
  return {
    url : process.env.APP_SERVICE + `/deviceManagement/${deviceId}/rbTestResult`
  }
}

function fetchRBConfigURL() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/rbConfig"
  }
}

function getFetchISEReportInfo(){
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/iseCalibrationReports"
  };
}

function fetchCalReportConfigURL() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/calibrationConfig"
  };
}

function getFetchChemCalReportInfo(){
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/chemCalibrationReports"
  };
}

function getUploadSoftwareURL() {
  return {
    url:  process.env.RSU_URL+"/rsu/uploadSoftware"
  };
}

function fetchDataLakeDetails() {
  return {
    url: process.env.RSU_URL + "/rsu/dataLakeDetails"
  };
}

function softwareListAndFilterOptionsURL() {
  return {
    url: process.env.RSU_URL + "/rsu/softwareListAndFilterOptions"
  };
}

function updateSoftwareStopShipmentURL() {
  return {
    url: process.env.RSU_URL + "/rsu/updateStopShipment"
  };
}

function deleteSoftwareURL() {
  return {
    url: process.env.RSU_URL + "/rsu/deleteSoftware"
  };
}

function downloadSoftwareURL() {
  return {
    url: process.env.RSU_URL + "/rsu/downloadSoftware"
  };
}

function pollUploadStatusURL() {
  return {
    url: process.env.RSU_URL + "/rsu/uploadStatus"
  };
}

function getInstrumentTriggeredRule(instanceId,days = 90, offset = 0, actionType = ""){
  const actionTypeParam = actionType ? `&actionType=${encodeURIComponent(actionType)}` : "";
  return {
        url: process.env.TRIGGERS_URL + `/triggers/rules?instanceId=${instanceId}&days=${days}&offset=${offset}${actionTypeParam}`
  }
}

function getDashboardSystemStatusURL(deviceId) {
  return {
    url: process.env.TELEMETRY_URL + "/devicetelemetry/devices/" + encodeURIComponent(deviceId) + "/dashboard/system",
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  };
}

function getDashboardQCStatusURL(deviceId) {
  return {
    url: process.env.TELEMETRY_URL + "/devicetelemetry/devices/" + encodeURIComponent(deviceId) + "/dashboard/qc",
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  };
}

function getDashboardEventURL(deviceId) {
  return {
    url: process.env.TELEMETRY_URL + "/devicetelemetry/devices/" + encodeURIComponent(deviceId) + "/dashboard/event",
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  };
}

function getActivityCountURL(deviceId) {
  return {
    url: process.env.TELEMETRY_URL + "/devicetelemetry/devices/" + encodeURIComponent(deviceId) + "/activityCount",
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  };
}

function deleteActivityCountURL(deviceId) {
  return {
    url: process.env.TELEMETRY_URL + "/devicetelemetry/devices/" + encodeURIComponent(deviceId) + "/activityCount",
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  };
}

function getModelComponentConfigURL(deviceId) {
  return {
    url: process.env.TELEMETRY_URL + "/devicetelemetry/devices/" + encodeURIComponent(deviceId) + "/model-component-config",
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  };
}

function getDXHSystemStatusURL(deviceId, systemParameter, fromDate, toDate, page = 0, size = 25) {
  return {
    url: process.env.TELEMETRY_URL + "/devicetelemetry/devices/" + encodeURIComponent(deviceId) + "/systemStatus/" + encodeURIComponent(systemParameter) + "?fromDate=" + encodeURIComponent(fromDate) + "&toDate=" + encodeURIComponent(toDate) + "&page=" + page + "&size=" + size,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  };
}

function getQCStatusURL(deviceId, controlType, lotNumber) {
  return {
    url: process.env.TELEMETRY_URL + "/devicetelemetry/devices/" + encodeURIComponent(deviceId) + "/qc/" + encodeURIComponent(controlType) + "/lot/" + encodeURIComponent(lotNumber),
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  };
}

function getLotNumberByDeviceIdURL(deviceId, controlType) {
  return {
    url: process.env.TELEMETRY_URL + "/devicetelemetry/devices/" + encodeURIComponent(deviceId) + "/qc/" + encodeURIComponent(controlType) + "/lots",
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  };
}

function getLastConnectionURL(deviceId) {
  return {
    url: process.env.TELEMETRY_URL + "/devicetelemetry/devices/" + encodeURIComponent(deviceId) + "/rmsDetails",
    repeat: true,
    interval: NGI_APIS_INTERVAL_30_SECS,
    inputHeader: { [AUTH_OBJECT_KEY_NAME]: deviceId }
  };
}

function fetchServiceMaxURL(){
   return {
        url: process.env.TRIGGERS_URL + "/triggers/serviceMaxURL"
  }
}

function getFleetCommandURL() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/fleet-commands"
  };
}

function getVerifyRDSURL(rdsUrl, instanceId) {
  return {
    url: rdsUrl + "/verifyRDS?instanceId=" + instanceId
  };
}

function getLaunchRDSURL(rdsUrl) {
  return {
    url: rdsUrl + "/launchRDS"
  };
}

function getDeviceBackupRestoreURL() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/device-backup-restore"
  };
}

function getFirewallUploadConfigURL() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/firewall-upload-config"
  };
}

function getRightToBeForgottenFeatureEnabledURL() {
  return {
    url: process.env.APP_SERVICE + "/deviceManagement/rightToBeForgotten"
  };
}


export {
  getPrimaryInstanceIdUrl,
  getBasicDeviceSearchUrl,
  getDeviceHeartBeatUrl,
  getDeviceDemographicsUrl,
  getFileUploadDefPathsUrl,
  getFileUploadDirListUrl,
  getFilesUrl,
  getFileDownloadUrl,
  getFileUploadUrl,
  getFileDownloadHistoryUrl,
  getAllFilesHistoryUrl,
  getDeleteFilesUrl,
  getResendFilesUrl,
  getDatalakeDetailsUrl,
  getDeleteAllFilesUrl,
  getAllDevicesForUserUrl,
  getUserSettingPreferencesUrl,
  getAllowedDeviceFeaturesUrl,
  getInstConnStatusInfoUrl,
  getTestsKpiInfoUrl,
  getMetricsListViewDataUrl,
  getMetricFilterUrl,
  getRSUModUrl,
  getAllowedFeaturesUrl,
  getCriticalWarningUrl,
  getPatientTotalTestUrl,
  getConnectivityUrl,
  getRecentCalibandQCAssayNameApiURL,
  getRecentCalibandQCAssayLotNumberApiURL,
  getRecentMetricDataApiURL,
  getHomePageListViewURL,
  getHomePageDropdownListURL,
  getModActionURL,
  getWorkOrderStatusURL,
  getBannerMessageUrl,
  saveBannerMessageUrl,
  getRolesForUserUrl,
  getCaCertURL,
  getDownloadCaCertURL,
  getFailedCalibIncidentURL,
  getFailedQCIncidentURL,
  getIncidentDataURL,
  getDeviceComponentListURL,
  getDeviceComponentMetricsURL,
  getDeviceComponentMeasurementValsURL,
  getEventDetailsURL,
  getCalAssaySummApiURL,
  getQCAssaySummApiURL,
  getEnrollmentStateURL,
  getUnenrollInstrumentURL,
  getHomePageStatCardsURL,
  getInstrumentStatCardsURL,
  getUserMangementURL,
  getUserMangementGroupDetailsURL,
  getAddUserURL,
  getReomveUserURL,
  getUserAssignedGroupURL,
  getUnassignedDevicesURL,
  getSearchDevicesURL,
  getInstGroupDevicesURL,
  getDeviceGroupsURL,
  getAddOrRemoveDevicesToInstGroupURL,
  getInstGroupsForMappingURL,
  getfetchUserDetailsURL,
  addUsertoISURL,
  deleteUsertoISURL,
  getUserGroupsForMappingURL,
  getAllowedModelsForMeteringURL,
  getUpdateDeviceMeteringStatusURL,
  getMaxUnrollmentInstrumentCountURL,
  getAdminAssignGroupURL,
  getMessageFreqModeURL,
  fetchOnboardInstrumentModelURL,
  getModelListURL,
  getMeteringDataFilterURL,
  getMeteringDataURL,
  getMeterZipUploadHistoryListURL,
  getConfigForInstrumentModel,
  getSampleStatsDataURL,
  getMeterUploadHistoryFiltersURL,
  uploadMeterZipURL,
  getWatchlistURL,
  getUserSearchHistoryURL,
  addOrRemoveFromWatchlistURL,
  getUserManualURL,
  retrieveFilesUrl,
  getSiteViewFiltersURL,
  getCustomerSitesURL,
  getSiteInstrumentsDataURL,
  getfetchDropdownOptionURL,
  getfetchInstrumentsURL,
  getfetchUserGroupDropdownOptionURL,
  getfetchUsersURL,
  getfetchRulesURL,
  getfetchCreateTriggerURL,
  getfetchTriggerActivityURL,
  getfetchTriggerAuditCountURL,
  getDiagnosticsTypeURL,
  getDiagnosticsSupportURL,
  getDiagDataURL,
  getDiagDateURL,
  getAnalyzerUnitURL,
  getPipettorMatchURL,
  getPipettorMatchReportURL,
  getCarryOverReportURL,
  getCarryoverSummaryURL,
  getLowVolumeURL,
  getLowVolumeReportURL,
  getSystemCheckURL,
  getSystemCheckReportURL,
  getMaintenanceDataUrl,
  getSupportedFeaturesForModelUrl,
  getMaintenanceDetailsUrl,
  getMaintenanceDomainsUrl,
  exportCSVPhotocalMonitorURL,
  getRuleSearchDataURL,
  getRuleViewDataURL,
  setTriggerStatusURL,
  deleteTriggerURL,
  getOfflineTriggerConfigURL,
  getCalHistoryURL,
  getRBHistoryURL,
  getEditTriggerInfoURL,
  getRBReportUrl,
  getRBreagentAndLotNumberUrl,
  fetchRBConfigURL,
  getRBDataUrl,
  fetchCalReportConfigURL,
  getFetchISEReportInfo,
  getFetchChemCalReportInfo,
  getUploadSoftwareURL,
  fetchDataLakeDetails,
  softwareListAndFilterOptionsURL,
  updateSoftwareStopShipmentURL,
  deleteSoftwareURL,
  downloadSoftwareURL,
  pollUploadStatusURL,
  getRAPBoxSearchUrl,
  getRAPBoxUploadFileUrl,
  getRAPBoxTransferredFilesUrl,
  getRAPBoxFileDownloadUrl,
  getLaunchRAPBoxRDSUrl,
  getLaunchRAPBoxRDSSessionUrl,
  getInstrumentTriggeredRule,
  getFleetCommandURL,
  getDashboardSystemStatusURL,
  getDashboardQCStatusURL,
  getDashboardEventURL,
  getModelComponentConfigURL,
  getActivityCountURL,
  deleteActivityCountURL,
  getDXHSystemStatusURL,
  getQCStatusURL,
  getLotNumberByDeviceIdURL,
  fetchServiceMaxURL,
  getVerifyRDSURL,
  getLaunchRDSURL,
  getLastConnectionURL,
  getDeviceBackupRestoreURL,
  getFirewallUploadConfigURL,
  getRightToBeForgottenFeatureEnabledURL
};
